export default __webpack_public_path__ + "static/media/likeSelectedLavander.c6e0c8f8.svg";